import {FC} from 'react';
import clsx from 'clsx';
import Pill from 'components/Pill';

export type TagsValueProps = {
    className?: string;
    value: string[];
};

const TagsValue: FC<TagsValueProps> = ({className, value}) => (
    <div className={clsx('flex flex-wrap gap-2', className)}>
        {value.map((label) => (
            <Pill key={label} color="grey" label={label} />
        ))}
    </div>
);

export default TagsValue;
